// This file automatically generated by skymarshal.
// DO NOT MODIFY BY HAND!!!!
//
// From Source File: util/skybus_websocket/lcmtypes/skybus_websocket.lcm


import Long from "long";
import Decoder from "@skydio/lcm/src/decoder";
import Encoder from "@skydio/lcm/src/encoder";
import LcmMsg from "@skydio/lcm/src/lcm";
import ReflectionMeta from "@skydio/lcm/src/reflection";

export class skybus_ws_subscribe_t extends LcmMsg {

  private static _hash = Long.fromString("1529611119281390264", true);
  private static _packed_fingerprint?: Long;

  /** @internal */
  public static override _get_packed_fingerprint(): Long {
    if (skybus_ws_subscribe_t._packed_fingerprint === undefined) {
      skybus_ws_subscribe_t._packed_fingerprint = skybus_ws_subscribe_t._get_hash_recursive([]);
    }
    return skybus_ws_subscribe_t._packed_fingerprint;
  }

  /** @internal */
  public static override _get_hash_recursive(parents: any[]): Long {
    if (parents.indexOf(skybus_ws_subscribe_t) > -1) {
      return Long.fromNumber(0, true);
    }
    let tmp_hash = skybus_ws_subscribe_t._hash;
    return tmp_hash.shl(1).add(tmp_hash.shru(63));
  }

  /** @internal */
  public static override _reflection_meta: ReflectionMeta = {
    channel: { kind: "primitive", type: String, typeStr: "string" },
  };

  public channel: string;

  public override decode(byte_array: Uint8Array): skybus_ws_subscribe_t {
    const decoder = new Decoder(new DataView(
      byte_array.buffer, byte_array.byteOffset, byte_array.byteLength
    ));
    const hash = decoder.decode_hash();
    if (!hash.equals(skybus_ws_subscribe_t._get_packed_fingerprint())) {
      console.error("Hash mismatch", hash, skybus_ws_subscribe_t._get_packed_fingerprint());
      throw new Error("Hash mismatch!");
    }
    this.decode_one(decoder);
    return this;
  }

  public override decode_one(decoder: Decoder): skybus_ws_subscribe_t {
    this.channel = decoder.decode_string();
    return this;
  }

  /** @internal */
  public _get_encoded_size(): number {
    let total_size = 0;
    total_size += 4 + new TextEncoder().encode(this.channel).length + 1;
    return total_size;
  }

  public override encode(): ArrayBufferLike {
    const encoder = new Encoder(8 + this._get_encoded_size()); // hash + rest
    encoder.encode_hash(skybus_ws_subscribe_t._get_packed_fingerprint());
    this.encode_one(encoder);

    return encoder.view.buffer;
  }

  public override encode_one(encoder: Encoder): void {
    encoder.encode_string(this.channel);
  }

  constructor(init?: {channel?: string }) {
    super();
    this.channel = "";

    // optionally override default values
    if (!init) {
      return;
    }
    this.channel = init.channel || this.channel;
  }
}